export const structureOptionsReducerKey = 'StructureOptionsReducerKey';

export const fetchInitialOptionsType = 'FETCH_INITIAL_OPTIONS_TYPE';
export const createInitialOptionsCopyType = 'CREATE_INITIAL_OPTIONS_COPY_TYPE';
export const toggleRadioOptionType = 'toggleRadioOptionType';
export const toggleCheckboxOptionType = 'toggleCheckboxOptionType';
export const updateOptionType = 'updateOptionType';
export const updateSavedInfoWithCurrentType = 'updateSavedInfoWithCurrentType';
export const setCurrentOptionsSameAsSavedType = 'setCurrentOptionsSameAsSavedType';
